// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameISOWeekYear as fn } from "../isSameISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameISOWeekYearWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isSameISOWeekYearWithOptions;
